import type {
    ReminderDismissAllRequest,
    ReminderDismissRequest,
    ReminderDismissResponse,
    ReminderListResponse,
    ReminderSummaryResponse,
} from '../types/reminder'
import api from '../utils/axiosConfig'

const normalizeReminderParams = (params: {
    limit?: number
    offset?: number
    daysThreshold?: number
}) => ({
    limit: params.limit ?? 10,
    offset: params.offset ?? 0,
    ...(params.daysThreshold === undefined
        ? {}
        : { days_threshold: params.daysThreshold }),
})

export const getReminderSummary = async (
    daysThreshold?: number
): Promise<ReminderSummaryResponse> => {
    const response = await api.get<ReminderSummaryResponse>('/reminders/summary', {
        params:
            daysThreshold === undefined
                ? undefined
                : { days_threshold: daysThreshold },
    })
    return response.data
}

export const getReminders = async (
    params: {
        limit?: number
        offset?: number
        daysThreshold?: number
    } = {}
): Promise<ReminderListResponse> => {
    const response = await api.get<ReminderListResponse>('/reminders', {
        params: normalizeReminderParams(params),
    })
    return response.data
}

export const dismissReminder = async (
    payload: ReminderDismissRequest
): Promise<ReminderDismissResponse> => {
    const response = await api.post<ReminderDismissResponse>(
        '/reminders/dismiss',
        payload
    )
    return response.data
}

export const dismissAllReminders = async (
    payload: ReminderDismissAllRequest = {}
): Promise<ReminderDismissResponse> => {
    const response = await api.post<ReminderDismissResponse>(
        '/reminders/dismiss-all',
        {
            reminder_type: payload.reminder_type,
            days_threshold: payload.days_threshold,
        }
    )
    return response.data
}
